import React from "react";
import PartInstallationComponentPage from "../production/PartInstallationComponentPage";


const LineSimulationPage = (props) => {


    return <>


        <PartInstallationComponentPage
        />

    </>;
}

export default LineSimulationPage;

